// src/services/settingService.js
import api from "./api";

/**
 * Busca a configuração do usuário logado.
 * Mapeia para GET /api/Settings
 * @returns {Promise<AxiosResponse<SettingReadDto>>}
 */
export function getSetting() {
  return api.get("/settings");
}

/**
 * Cria ou atualiza a configuração do usuário logado.
 * Mapeia para PUT /api/Settings
 * @param {object} data - SettingUpdateDto (uncategorizedTextColor, etc.)
 * @returns {Promise<AxiosResponse<SettingReadDto>>}
 */
export function createOrUpdateSetting(data) {
  // Usamos PUT para a operação idempotente de Criar ou Atualizar
  return api.put("/settings", data);
}

/**
 * Exclui a configuração do usuário logado.
 * Mapeia para DELETE /api/Settings
 * @returns {Promise<AxiosResponse<object>>}
 */
export function deleteSetting() {
  return api.delete("/settings");
}
